//
//
//
//
//

import blokPage from '~/mixins/blok-page'

export default {
  mixins: [blokPage],
  props: {
    path: {
      type: String,
      default: null
    },
    absPath: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      blokOriginal: null,
      blokVariant: null,
      isVariant: false,
      experimentActivated: false
    }
  },
  async fetch () {
    try {
      this.blokOriginal = await this.$sb.get(`cdn/stories/${this.absolutePath}`).then(r => r.data.story.content)
      if (this.blokOriginal.variant_test?.cached_url) {
        this.blokVariant = await this.$sb.get(`cdn/stories/${this.blokOriginal.variant_test?.cached_url}`).then(r => r.data.story.content)
      }
    } catch (e) {
      if (e.response) {
        // eslint-disable-next-line no-console
        console.error(e.response.data)
      } else {
        // eslint-disable-next-line no-console
        console.error(e)
      }

      this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
    }
  },
  computed: {
    currentBlok () {
      return this.isVariant ? this.blokVariant : this.blokOriginal
    },
    relativePath () {
      return this.path || this.$route.params.page || ''
    },
    absolutePath () {
      return this.absPath || `${this.$country.current.code}/${this.relativePath}`
    },
  },
  watch: {
    blokVariant (blok) {
      // We have to activate here also because
      // on local environment, the fetch will be called
      // after mounting on client side navigation
      this.loadExperiment()
    }
  },
  mounted () {
    this.loadExperiment()
  },
  methods: {
    loadExperiment () {
      if (!this.blokOriginal || !this.blokVariant || this.experimentActivated || !this.blokOriginal?.feature_flag_key) {
        return
      }

      this.$ph.onFeatureFlags(() => {
        this.isVariant = this.$ph.getFeatureFlag(this.blokOriginal.feature_flag_key) === 'test'
      })

      this.experimentActivated = true
    }
  },
  fetchKey (getCounter) {
    return `storyblok-page:${this.relativePath}:${getCounter('storyblok-page')}`
  },
}
